import { put, takeLatest } from "redux-saga/effects";
import {
  postApplicationsGetGuidepost,
  getApplicationsGetCurrentDocs,
  postApplicationsLogApplicationVisit,
  DocumentationDto,
} from "Api/Api";
import { getType } from "typesafe-actions";
import { call } from "typed-redux-saga";
import {
  getGuidepostAsync,
  postGuidepostLogAppVisitAsync,
} from "State/Guidepost/GuidepostReducer";

function* getGuidepost(
  action: ReturnType<typeof getGuidepostAsync.request>,
): Generator {
  try {
    const guidepostResponse = yield* call(postApplicationsGetGuidepost);
    const docsResponse = yield* call(
      getApplicationsGetCurrentDocs,
      action.payload,
    );

    if (guidepostResponse.status === 200) {
      yield put(
        getGuidepostAsync.success({
          guidepost: guidepostResponse.json,
          documentation: docsResponse.json.data ?? ({} as DocumentationDto),
        }),
      );
    } else {
      yield put(getGuidepostAsync.failure(new Error()));
    }
  } catch (err) {
    yield put(getGuidepostAsync.failure(err));
  }
}
export function* getGuidepostSaga() {
  yield takeLatest(getType(getGuidepostAsync.request), getGuidepost);
}

function* postGuidepostLogAppVisit(
  action: ReturnType<typeof postGuidepostLogAppVisitAsync.request>,
): Generator {
  try {
    const response = yield* call(
      postApplicationsLogApplicationVisit,
      action.payload,
    );
    if (response.status === 200) {
      yield put(postGuidepostLogAppVisitAsync.success(response.json));
    } else {
      yield put(postGuidepostLogAppVisitAsync.failure(new Error()));
    }
  } catch (err) {
    yield put(postGuidepostLogAppVisitAsync.failure(err));
  }
}
export function* postGuidepostLogAppVisitSaga() {
  yield takeLatest(
    getType(postGuidepostLogAppVisitAsync.request),
    postGuidepostLogAppVisit,
  );
}
